/**
 * File: ga4Service.ts
 * Path: apps/admin/src/features/dashboard/ga4Service.ts
 * Description: Fetches the GA4 website report through the regionalized Firebase Functions instance.
 */

import { httpsCallable } from "firebase/functions";
import { getFunctionsInstance } from "@idk/config";
import type { Ga4ReportResponse } from "@/features/dashboard/utils/ga4Utils";
import type { DateRange } from "@/features/dashboard/utils/dateRangeUtils";

interface Ga4ReportRequest extends DateRange {
  metrics: string[];
  dimensions: string[];
}

export const fetchTrafficReport = async (range: DateRange): Promise<Ga4ReportResponse> => {
  // Enforce the use of the pre-configured instance to guarantee requests land in FUNCTIONS_REGION
  const functions = getFunctionsInstance();
  const fetchGa4DataProxy = httpsCallable<Ga4ReportRequest, Ga4ReportResponse>(functions, "fetchGa4Data");

  // Property ID is resolved on the server-side from Google Secret Manager
  const response = await fetchGa4DataProxy({
    startDate: range.startDate,
    endDate: range.endDate,
    metrics: ["activeUsers", "sessions", "engagementRate"],
    dimensions: ["date"],
  });
  return response.data;
};
